"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelList = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ = _interopRequireDefault(require("."));
var LabelList = exports.LabelList = function LabelList(_ref) {
  var _ref$labels = _ref.labels,
    labels = _ref$labels === void 0 ? [] : _ref$labels,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$maxLabels = _ref.maxLabels,
    maxLabels = _ref$maxLabels === void 0 ? Infinity : _ref$maxLabels,
    isSmall = _ref.isSmall,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  return !(0, _isEmpty2["default"])(labels) ? /*#__PURE__*/_react["default"].createElement(StyledWrapper, {
    className: className
  }, labels.map(function (label, index) {
    if (index >= maxLabels) return null;
    var id = label.id,
      title = label.title,
      description = label.description,
      style = label.style;
    return /*#__PURE__*/_react["default"].createElement(_["default"], {
      isMobile: isMobile,
      key: id,
      title: title,
      style: style,
      description: description,
      isSmall: isSmall
    });
  })) : null;
};
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LabelList__StyledWrapper",
  componentId: "sc-1k9p1vn-0"
})(["display:flex;flex-wrap:wrap;"]);